import template from './area-land.jade';
import validation from '../../../services/validation';
import areaUnits from '../../../enums/area-units';

export default angular
.module('cian.addForm.areaLand', [])
.directive('cianAfAboutObjectAreaLand', () => ({
    scope: {},
    bindToController: {
        ad: '=',
        form: '=',
    },
    controller: ['deviceService', function (deviceService) {
        this.isMobile = deviceService.isMobile;
        this.areaUnitOptions = areaUnits;

        if (!this.ad.land) {
            this.ad.land = {};

            if (!this.ad.land.areaUnitType) {
                this.ad.land.areaUnitType = this.areaUnitOptions[0].key;
            }
        }

        this.areaMax = 10000000;
        this.areaMin = 0;

        this.validationArea = validation(this.form, 'areaLandValue', {
            parse: 'Введите число',
            min: 'Площадь должна быть больше 0',
            max: 'Допустимо не более 7 символов',
            required: 'Укажите площадь участка',
        });

        this.validationUnit = validation(this.form, 'land.areaUnitType', {
            required: 'Укажите единицы измерения',
        });
    }],
    controllerAs: 'areaLand',
    template,
}))
.name;
